<template>
  <div>
    <a-row class="content" v-if="infoIndex === 0">
      <a-col :span="15">
        <project-edit :projectId="projectId" @update="update" :usefor="'page'" ref="projectConfig"></project-edit>
      </a-col>
      <a-col :span="1" v-if="true"></a-col>
      <a-col :span="8" v-if="true">
        <div class="info-content" v-if="showMap.showBusiness">
          <div class="title">工商信息</div>
          <a-button type="link" @click="toInfoDetail(1)" class="link-btn " data-ga-id="项目-项目信息-点击业务所在地" >业务所在地</a-button>
        </div>
        <div class="info-content" v-if="showMap.showTransaction">
          <div class="title">
            交易模块信息
            <a-tooltip placement="top" v-if="legalProjectId">
              <template slot="title">
                <span>已绑定交易模块</span>
              </template>
              <a-button type="link"><a-icon type="link"/></a-button>
            </a-tooltip>
            <a-button v-else-if="permissionMap.createLegal" type="link" size="small" shape="round" @click="createLegalProject">创建&绑定项目</a-button>
          </div>
          <a-button class="link-btn" data-ga-id="项目-项目信息-点击目标企业链接" type="link" @click="toLegalProject" :disabled="!legalProjectId">目标企业链接</a-button>
        </div>
        <div class="info-content" v-if="showMap.showPortfolio && (project.base || {}).oldMark === 2">
          <div class="title">Portfolio信息</div>
          <a-button type="link" class="link-btn" @click="toInfoDetail(2)">Portfolio官方信息介绍</a-button>
        </div>
        <div class="info-content" v-if="showMap.showMahui">
          <div class="title code-class-bind">投后服务信息</div>
          <a-button data-ga-id="项目-项目信息-点击创建&绑定项目" type="link" size="small" shape="round" @click="bindToCodeClass" v-if="!bindedCodeClass"
            ><div v-if="permissionMap.codeClass">创建&绑定项目</div></a-button
          >
          <a-tooltip placement="top" v-else>
            <template slot="title">
              <span>已绑定投后管理后台</span>
            </template>
            <a-button type="link"><a-icon type="link"/></a-button>
          </a-tooltip>
        </div>
        <feishu-group :project-id="projectId"></feishu-group>
      </a-col>
    </a-row>
    <businessLocation v-if="infoIndex === 1" :companyId="projectId"></businessLocation>
    <portfolio-config v-if="infoIndex === 2" :companyId="projectId"></portfolio-config>
    <member-history v-if="infoIndex === 3" :companyId="projectId"></member-history>
  </div>
</template>

<script>
/* eslint-disable */
import { ifLegalCompanyExist, legalCompanyManage, bindToCodeClass } from '@/api/project';
import projectEdit from '@/components/project/projectEdit';
import portfolioConfig from '@/components/project/portfolioConfig';
import businessLocation from '@/components/project/businessLocation';
import memberHistory from '@/components/project/memberHistory';
import { getPermissions } from '@/utils/utils';
import feishuGroup from '@/views/project/feishuGroup/index';
import Event from '@/utils/event';
import { getToken } from '@/assets/js/auth';
import { legalMap } from '@/common/constant';

export default {
  name: 'projectInfo',
  components: {
    projectEdit,
    portfolioConfig,
    businessLocation,
    memberHistory,
    feishuGroup
  },
  props: {
    projectId: {
      type: [String, Number],
      default() {
        return '';
      }
    },
    project: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      legalProjectId: null,
      infoIndex: 0,
      showMap: { showTransaction: false, showPortfolio: false, showBusiness: false, showMahui: false },
      permissionMap: {},
      bindedCodeClass: false
    };
  },
  created() {
    this.fetchLegalInfo();
    this.initPermissions();
  },

  mounted() {
    Event.$on('toInfoDetail', index => {
      this.infoIndex = index;
    });
  },

  watch: {
    project: {
      handler(val) {
        let { showTransaction, showPortfolio, showBusiness, showMahui } = val;
        this.showMap = { showTransaction, showPortfolio, showBusiness, showMahui };
        if (val.mahui && val.mahui.bindToMahui) {
          this.bindedCodeClass = val.mahui.bindToMahui;
        }
      },
      immediate: true
    }
  },
  methods: {
    toInfoDetail(index) {
      Event.$emit('toInfoDetail', index);
    },
    toMemberHistory() {
      Event.$emit('toInfoDetail', 3);
    },
    async fetchLegalInfo() {
      try {
        let res = await ifLegalCompanyExist({ companyId: this.projectId });
        if (res.code === 200) {
          this.legalProjectId = res.data;
        } else {
          this.legalProjectId = null;
        }
      } catch (e) {}
    },
    createLegalProject() {
      this.$confirm({
        title: `确定在法务系统中创建项目并绑定到此项目么？`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          legalCompanyManage({ companyId: this.projectId }).then(res => {
            if (res.code === 200) {
              this.$message.success('创建成功');
              this.fetchLegalInfo();
            }
          });
        }
      });
    },
    toLegalProject() {
      let path = encodeURIComponent(`/admin/company/check?id=${this.legalProjectId}`);
      let legalHost = legalMap[window.location.host];
      let jumpUrl = `${legalHost}/admin/cros?token=${getToken()}&url=${path}`;
      window.open(jumpUrl);
    },
    update() {
      this.$emit('update');
    },
    initPermissions() {
      let keyList = ['createLegal', 'codeClass'];
      this.permissionMap = getPermissions(keyList);
    },
    bindToCodeClass() {
      try {
        this.$confirm({
          title: '确定在投后管理后台系统中创建项目并绑定到此项目么？',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk: () => {
            bindToCodeClass({ companyId: this.projectId }).then(res => {
              if (res.code === 200) {
                this.$message.success('创建成功');
                this.bindedCodeClass = true;
              }
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.info-content {
  display: flex;
  align-items: center;
  border: 1px solid #e9e9e9;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 10px;
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }
  .code-class-bind {
    margin-right: 0px;
  }
}
.link-btn {
  padding-left: 0;
}
</style>
